import Image from "@/components/Image";
import { Link } from "react-router-dom";
import { CampaignType } from "../apis/campaign";
import Timeline from "./timeline";

type Props = {
    data: CampaignType | undefined;
    onCloseDetail: () => void;
};

export default function Detail({ data, onCloseDetail }: Props) {
    if (!data) {
        return null;
    }

    return (
        <div className="pb-10 h-full text-white overflow-auto md:overflow-hidden">
            <div className="text-base md:text-[40px] md:leading-[48px] p-4 pr-10 md:px-10 md:pt-10 md:pb-8 relative text-white">
                <p className="truncate">{data.title}</p>
                <button
                    type="button"
                    className="absolute top-4 right-4"
                    onClick={onCloseDetail}
                >
                    <Image
                        src={require("@/assets/icons/close-white.svg")}
                        width={24}
                        height={24}
                        alt=""
                        className=""
                    />
                </button>
            </div>
            <div className="w-full  h-[1px] bg-white opacity-10" />
            <div className="flex flex-col md:flex-row md:h-[65%] ">
                <div className="p-4 md:px-10 md:py-8 md:basis-2/3">
                    <div
                        className="content-detail h-full overflow-auto text-white"
                        dangerouslySetInnerHTML={{ __html: data.content ?? "" }}
                    />
                </div>

                <div className="md:basis-1/3 border border-l-solid border-y-0  border-r-0 border-l-transparent4 py-6 px-5">
                    <Timeline timeLine={data.timeLine} />
                </div>
            </div>
            <div className="w-full  h-[1px] bg-white opacity-10" />

            <div className="flex flex-col md:flex-row items-center justify-between gap-2 p-4 md:pt-6 md:pl-[60px] md:pr-[100px]">
                <p className="text-transparent3 flex-1 flex justify-center">
                    {data.subTitle}
                </p>
                <Link to={data.seeMoreUrl} target="_blank">
                    <button
                        type="button"
                        className="bg-white text-black flex items-center justify-center gap-x-2 px-5 py-4 w-[163px]  rounded-full font-medium"
                    >
                        See more
                        <Image
                            src={require("@/assets/icons/arrow-black.svg")}
                            width={24}
                            height={24}
                            alt=""
                            className="w-5 h-5"
                        />
                    </button>
                </Link>
            </div>
        </div>
    );
}
